//All variables declaration
var allBundlebtns = document.querySelectorAll(".cstm_bundle_btn");
var allcolbtns=document.querySelectorAll(".main_btn")
var drawerNoproducts = document.querySelector(".total_Selected_products");
var itemsBundle = document.querySelector(".items_in_bundle");
var allBoxButtons = document.querySelectorAll(".Btn__add_toooBox");
var checkout_btn= document.querySelector(".atcbtn");
var checkoutParent = checkout_btn.parentNode;
var bundleDrawer = document.querySelector(".drawer_container_bundle");
var main_content = document.querySelector(".main_body");
var save_and_continue_btn = document.querySelector(".save_and_continue .main_save-contunue_shopping_btn");
var continue_btn= document.querySelector('.continue_shopping_btn')
var drawer_seletectedprds=document.querySelector(".product_qty_inside");
var noofprdsDrawer=document.querySelector(".total_selected_prds");
var subscription_checkbox=document.querySelector(".subscription_checkmain");
var subscription_details_main=document.querySelector(".subscription_details_main");
var product_page_btn=document.querySelector(".add-box-sec button");


// Select required elements
// Ensure all elements are found before proceeding
if (drawer_seletectedprds && noofprdsDrawer && bundleDrawer) {
    // Compare the text content of the elements
    var selectedValue = parseInt(drawer_seletectedprds.textContent.trim(), 10);
    var totalValue = parseInt(noofprdsDrawer.textContent.trim(), 10);

    if (selectedValue === totalValue) {
        // Add 'fullopen' class if values match
        bundleDrawer.classList.add("fullopen");
    } else {
        // Remove 'fullopen' class if values do not match
        bundleDrawer.classList.remove("fullopen");
    }
}





//subscription_widget hideshow
function subscriptionWidgetHideshow(){
subscription_checkbox.addEventListener("change", function(){
  if (subscription_checkbox.checked){
    subscription_details_main.style.display="flex";
    
  }
  else{
     subscription_details_main.style.display="none";
  }
})
}











//hideonhomepageifnoqty
function hidedraweronhomepage(){
  var insidedrawerqty = localStorage.getItem("lineItems");
  var availlengthdrawer = insidedrawerqty ? JSON.parse(insidedrawerqty) : [];

   console.log(availlengthdrawer.length);
   if (!availlengthdrawer.length > 0){
   bundleDrawer.classList.add("homenone");
     main_content.classList.add("homeLength");
   }
  else{
     bundleDrawer.classList.remove("homenone");
    main_content.classList.add("homeLength");
  }
}



// update Quantity in drawer
function updateQuantityinDrawer(){
   var drawerQty = localStorage.getItem("lineItems");
    var itemsDrawerqty = drawerQty ? JSON.parse(drawerQty) : [];


  drawer_seletectedprds.textContent=itemsDrawerqty.length;
  
};



//updateCartBubble
function updateCartBubble(){
  console.log("bubble");
};

//fullopen

function fullopenDrawer(){
  bundleDrawer.addEventListener("mouseover", function(){
    bundleDrawer.classList.add("fullopen");
  });
  bundleDrawer.addEventListener("mouseout", function(){
    bundleDrawer.classList.remove("fullopen");
  });
};






///halfopentransition
function halfOpenDrawer(){
  bundleDrawer.classList.add("halfopen");
  setTimeout(function(){
    bundleDrawer.classList.remove("halfopen");
},300)
}





//addingAllproducts to cart
function ADDtocartBundle() {

  
    if (checkout_btn) {
        checkout_btn.addEventListener("click", function() {
            var bundleVarientId = checkout_btn.getAttribute("data_var_id");
             var allLineitems = document.querySelectorAll(".bundle_item");
            var lineItemProperties = {};

            allLineitems.forEach(function(ele, index) {
                var productTitle = ele.querySelector(".product_Selected").textContent;
                

                
                lineItemProperties[`Cocktail ${index + 1}`] = productTitle;
                
            });
            console.log(lineItemProperties);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/cart/add.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        window.location.href = "/cart";
                        localStorage.clear();
                    } else {
                        console.log('Error adding item to cart');
                    }
                }
            };

            console.log(bundleVarientId)
            var data = JSON.stringify({
                id: bundleVarientId,
                properties: lineItemProperties
            });

            xhr.send(data);
        });
    } else {
        console.log('Checkout button not found');
    };


  
    if (save_and_continue_btn) {
        save_and_continue_btn.addEventListener("click", function() {
            var bundleVarientId = save_and_continue_btn.getAttribute("data_var_id");
             var allLineitems = document.querySelectorAll(".bundle_item");
            var lineItemProperties = {};

            allLineitems.forEach(function(ele, index) {
                var productTitle = ele.querySelector(".product_Selected").textContent;
                

                
                lineItemProperties[`Cocktail ${index + 1}`] = productTitle;
                
            });
            console.log(lineItemProperties);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', '/cart/add.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');

            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        updateCartBubble();
                        localStorage.clear();
                       location.reload();
                    } else {
                        console.log('Error adding item to cart');
                    }
                }
            };

            console.log(bundleVarientId)
            var data = JSON.stringify({
                id: bundleVarientId,
                properties: lineItemProperties
            });

            xhr.send(data);
        });
    } else {
        console.log('Checkout button not found');
    };
};

























//change varid from checkout button
function changeVarid(varientId){
  checkout_btn.setAttribute("data_var_id", varientId );
  save_and_continue_btn.setAttribute("data_var_id", varientId );
};


// Display checkout buttons function
function displayCheckoutbtn() {
    var totalNoofitems = localStorage.getItem("boxsize");
    var totalNoofitemsint = parseInt(totalNoofitems);
    var noofitemsadded = localStorage.getItem("lineItems");
    var itemsinArray = noofitemsadded ? JSON.parse(noofitemsadded) : [];
    var lenght_array = itemsinArray.length;

    if (totalNoofitemsint <= lenght_array) {
        checkoutParent.classList.add("allSelected");
        save_and_continue_btn.classList.add("allSelected");
        continue_btn.style.display = "none";

        // Drawer popup when the box gets full
        var drawerContainerBundle = document.querySelector("div.drawer_container_bundle");
        var bodyOverflowHiddenDrawerPresent = document.querySelector("body.drawerPresent");
        if (drawerContainerBundle) {
            drawerContainerBundle.classList.add("fullopen");
            bodyOverflowHiddenDrawerPresent.classList.add("overflowHidDrawerPresent");

            // Add hover functionality to remove the class
            drawerContainerBundle.addEventListener("mouseover", function () {
                if (bodyOverflowHiddenDrawerPresent.classList.contains("overflowHidDrawerPresent")) {
                    bodyOverflowHiddenDrawerPresent.classList.remove("overflowHidDrawerPresent");
                }
            });

            // Add click listener to remove classes when clicking outside
            // document.addEventListener("click", function (event) {
            //     // Check if the click is outside drawerContainerBundle
            //     if (!drawerContainerBundle.contains(event.target)) {
            //         if (bodyOverflowHiddenDrawerPresent.classList.contains("overflowHidDrawerPresent")) {
            //             bodyOverflowHiddenDrawerPresent.classList.remove("overflowHidDrawerPresent");
            //         }
            //         if (drawerContainerBundle.classList.contains("fullopen")) {
            //             drawerContainerBundle.classList.remove("fullopen");
            //         }
            //     }
            // });
        }

        // Close button functionality
        var boxCloseBtn = document.querySelector(".boxCloseBtn");
        if (boxCloseBtn) {
            boxCloseBtn.addEventListener("click", function () {
                // Remove classes on close button click
                if (bodyOverflowHiddenDrawerPresent.classList.contains("overflowHidDrawerPresent")) {
                    bodyOverflowHiddenDrawerPresent.classList.remove("overflowHidDrawerPresent");
                }
                if (drawerContainerBundle.classList.contains("fullopen")) {
                    drawerContainerBundle.classList.remove("fullopen");
                }
            });
        }
    } else {
        checkoutParent.classList.remove("allSelected");
        save_and_continue_btn.classList.remove("allSelected");
    }
}











//remove LineItems
function removeLineItemFromStorage(index) {
    var itemsArrayString = localStorage.getItem("lineItems");
    var itemsArray = itemsArrayString ? JSON.parse(itemsArrayString) : [];
   
    if (index > -1 && index < itemsArray.length) {
        itemsArray.splice(index, 1); 
    }

    localStorage.setItem("lineItems", JSON.stringify(itemsArray));
    
    updateLineItemsInDOM();
   displayCheckoutbtn();
  updateQuantityinDrawer();
  hidedraweronhomepage();
};






//get lineitems from storage
function updateLineItemsInDOM() {
    var itemsArrayString = localStorage.getItem("lineItems");
    var itemsArray = itemsArrayString ? JSON.parse(itemsArrayString) : [];

    var allItems = document.querySelectorAll(".bundle_item");
    
    allItems.forEach(function(item, index) {
      item.style.opacity= 1;
      var insideCircle=item.querySelector(".maincirclediv");
      insideCircle.classList.remove("empty");
      insideCircle.classList.add("added");
      
        if (index < itemsArray.length) {
            var titleElement = item.querySelector(".product_Selected");
            var colorElement = item.querySelector(".maincirclediv");

            titleElement.innerText = itemsArray[index].title;
            colorElement.style.backgroundColor = itemsArray[index].color;
            var deleteBtn=insideCircle.querySelector(".delete_product");
             
            deleteBtn.onclick = function() {
                removeLineItemFromStorage(index);
            };
        } else {
            item.style.opacity= 0.5;
            var titleElement = item.querySelector(".product_Selected");
            var colorElement = item.querySelector(".maincirclediv");

           titleElement.innerText = "Nothing Selected";
           colorElement.style.backgroundColor = ""; 
           insideCircle.classList.add("empty");
           insideCircle.classList.remove("added");
        }
      
    });
  
  halfOpenDrawer();
};






//Store in localstorage Array

function storelineitemsStorage( title , color , limit){
    var itemsArrayString = localStorage.getItem("lineItems");
    var itemsArray = itemsArrayString ? JSON.parse(itemsArrayString) : [];
    var newItem = { title: title, color: color };
    if (itemsArray.length >= limit) {
        console.log("You can't add more than " + limit + " items.");
        return;
    }
    checkoutParent.classList.remove("allSelected");
    itemsArray.push(newItem);
    localStorage.setItem("lineItems", JSON.stringify(itemsArray));
    updateLineItemsInDOM();
  updateQuantityinDrawer();
  hidedraweronhomepage();
};




//create items in bundle
 function createItems(noOfItems) {
    var itemHtml = `
        <li class='bundle_item'>
            <div class='maincirclediv empty'>
                <svg class='noSelected' width='15px' height='15px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
                    <g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'></g>
                    <g id='SVGRepo_iconCarrier'>
                        <path d='M4 12H20M12 4V20' stroke='#000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></path>
                    </g>
                </svg>
                <svg class='selected_product' width='15px' height='15px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='#000000'>
                    <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
                    <g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'></g>
                    <g id='SVGRepo_iconCarrier'>
                        <title></title>
                        <g id='Complete'>
                            <g id='tick'>
                                <polyline fill='none' points='3.7 14.3 9.6 19 20.3 5' stroke='#000000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'></polyline>
                            </g>
                        </g>
                    </g>
                </svg>
                <svg class='delete_product' width='20px' height='20px' viewBox='0 -0.5 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
                    <g id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'></g>
                    <g id='SVGRepo_iconCarrier'>
                        <path d='M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z' fill='#000000'></path>
                    </g>
                </svg>
            </div>
            <div class='product_Selected'>Nothing Selected</div>
        </li>`;
        
    
    itemsBundle.innerHTML = ""; // Clear existing items

    for (var i = 0; i < noOfItems; i++) {
        itemsBundle.innerHTML += itemHtml; // Append new items
    }
    updateLineItemsInDOM();
};




//Remove Selected class

function RemoveSelectedClass(){
  allBundlebtns.forEach(function(ele){
   ele.classList.remove("selected");
   var bundleS=ele.getAttribute("data_box_size");
   ele.querySelector(".btnPrimaryText").textContent="BUILD A BOX OF " + bundleS;
});
};



//On Select
function addSelectedClass(){
  
var selectedBtn = localStorage.getItem("BundleVariant");
var totalProduts=localStorage.getItem("boxsize");
var totalProductsInt= parseInt(totalProduts);
var BundleBtn = document.querySelector(`[data-varid="${selectedBtn}"]`);
 
drawerNoproducts.textContent=totalProductsInt;
  noofprdsDrawer.textContent=totalProductsInt;
  
if (BundleBtn) {
  BundleBtn.classList.add("selected");
  var innetxt=BundleBtn.querySelector(".btnPrimaryText");
  if(innetxt){
    innetxt.textContent="Selected"
  }
};
createItems(totalProductsInt);
};


//store variant id of bundle in localStorage
function bundleVarientLocal(varid , noOfProducts){
  localStorage.setItem("BundleVariant", varid );
  localStorage.setItem("boxsize", noOfProducts);
 
  RemoveSelectedClass();
  addSelectedClass();
  changeVarid(varid);
  halfOpenDrawer();
};
// collection

function bundleVarientLocalc(varid , noOfProducts){
  localStorage.setItem("BundleVariant", varid );
  localStorage.setItem("boxsize", noOfProducts);
  
  selectionOnCollection();
  changeVarid(varid);
  halfOpenDrawer();
  addSelectedClass();
};


//bundle buttons Click function
allBundlebtns.forEach(function(ele){
  ele.addEventListener("click", function(){
    var variantId =  ele.getAttribute("data-varid");
    var boxSize= ele.getAttribute("data_box_size");
   
   
    bundleVarientLocal(variantId , boxSize);
    
    
  });
});

allcolbtns.forEach(function(ele){
  ele.addEventListener("click", function(){
    var variantId =  ele.getAttribute("data-varid");
    var boxSize= ele.getAttribute("data_box_size");
  
    bundleVarientLocalc(variantId , boxSize);

    var getLocalStorage = localStorage.getItem("BundleVariant");
    if (getLocalStorage != null ) {
      bundleDrawer.style.display = '';
      main_content.style.width="";
    }

    // var itemsArrayString = localStorage.getItem("lineItems");
    // var itemsArray = itemsArrayString ? JSON.parse(itemsArrayString) : [];
    
    // // Check if the limit is reached
    // if (itemsArray.length >= limit) {
    //   // Add "fullopen" class to the drawer container
    //   var drawerContainerBundle = document.querySelector("div.drawer_container_bundle");
    //   if (drawerContainerBundle) {
    //     drawerContainerBundle.classList.add("fullopen");
    //   }
    // }
    
  });
});


//addingEventlistenr to buttons

allBoxButtons.forEach(function(ele){
  ele.addEventListener("click", function(){
  //store in local Storage
   var prdTitle = ele.getAttribute("data-prdtitle");
   var prdColor = ele.getAttribute("data-color");
   var boxSize=localStorage.getItem("boxsize");
   var boxSizeInt= parseInt(boxSize);
  
   storelineitemsStorage(prdTitle , prdColor , boxSizeInt);
   displayCheckoutbtn();
  
   
  });
});

//select button on collection page
function selectionOnCollection(){
 //remove selected_class

var allbtnsele=document.querySelectorAll(".main_product_inner");
  allbtnsele.forEach(function(ele){
    ele.classList.remove("selected");
    var btnc=ele.querySelector(".main_btn");
  var buS=btnc.getAttribute("data_box_size");
   btnc.style.background="white";
    btnc.style.color="black";
  btnc.innerHTML="<span>BUILD A BOX OF " + buS+ "</span>";
  })

  //add selected class
  
var selecit = localStorage.getItem("BundleVariant");
var totalp=localStorage.getItem("boxsize");
var totalPint= parseInt(totalp);
  console.log(selecit)
var bundlebtcol = document.querySelector(`[data-varid="${selecit}"]`);
 if (bundlebtcol){
var getparentcol=bundlebtcol.closest(".main_product_inner");

  if (getparentcol){
  getparentcol.classList.add("selected");
  }
   }
  if (bundlebtcol){
    bundlebtcol.innerHTML="<span>Selected</span>";
    bundlebtcol.style.background="black";
    bundlebtcol.style.color="white";
  }
  createItems(totalPint);
  
  
}



document.addEventListener("DOMContentLoaded",function(){
  fullopenDrawer();
   subscriptionWidgetHideshow();
   var LocalStorageSelected=localStorage.getItem("BundleVariant");
  
  if (LocalStorageSelected != null ) {
    RemoveSelectedClass();
    addSelectedClass();
    changeVarid(LocalStorageSelected);
    selectionOnCollection();
  }
  else{
    // var DefaultSelected=document.querySelector(".cstm_bundle_btn.selected").getAttribute("data-varid"); 
    // var boxSizeDefault=document.querySelector(".cstm_bundle_btn.selected").getAttribute("data_box_size");
    // bundleVarientLocal(DefaultSelected, boxSizeDefault );
    // changeVarid(DefaultSelected);
    // var drawer_main=document.querySelector(".drawer_container_bundle");
    // drawer_main.style.display="none";
    // var main_body=document.querySelector(".main_body");
    // main_body.style.width="100%";
  }

  
  halfOpenDrawer();
  updateLineItemsInDOM();
  displayCheckoutbtn();
  ADDtocartBundle();
  
  updateQuantityinDrawer();
  // hidedraweronhomepage();
  
});


//preselection

document.addEventListener("DOMContentLoaded",function(){
  //check local storage.
var selectedBundle = localStorage.getItem("BundleVariant");
var boxsizeM=localStorage.getItem("boxsize");
if (!selectedBundle && !boxsizeM  ){
  localStorage.setItem("BundleVariant", "49791820955979" );
  localStorage.setItem("boxsize", "6");
  var LocalStorageSelect=localStorage.getItem("BundleVariant");
  
    RemoveSelectedClass();
    addSelectedClass();
    changeVarid(LocalStorageSelect);
    selectionOnCollection();
}
  else{
  console.log("preselected");
  }
})
